import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import { store } from './store/store'
import connectToSokect from './store/socket'
import { populateHttp, updateHttp, updateHttpVolumen } from './store/populate'
import ReactHighcharts from 'react-highcharts'
import ReactHighStock from 'react-highcharts/ReactHighstock'
import { isConnect } from './store/listeners'
// Add feactures Highcharts
require('highcharts/highcharts-more')(ReactHighcharts.Highcharts)
require('highcharts/modules/exporting')(ReactHighcharts.Highcharts)
require('highcharts/modules/offline-exporting')(ReactHighcharts.Highcharts)
require('highcharts/modules/solid-gauge')(ReactHighcharts.Highcharts)
require('highcharts/modules/heatmap')(ReactHighcharts.Highcharts)
// Add Feactures HighStock
require('highcharts/highcharts-more')(ReactHighStock.Highcharts)
require('highcharts/modules/exporting')(ReactHighStock.Highcharts)
require('highcharts/modules/export-data')(ReactHighStock.Highcharts)
require('highcharts/modules/offline-exporting')(ReactHighStock.Highcharts)

// populate the redux state
populateHttp(store)
// Update every 5 minutes
updateHttp(store)
// Update every 5 minutes
updateHttpVolumen(store)

// init socket whit redux connection
connectToSokect(store)

// Add listeners
store.subscribe(isConnect(store, 'valledetenza'))
store.subscribe(isConnect(store, 'mochileros'))
store.subscribe(isConnect(store, 'paez'))
store.subscribe(isConnect(store, 'umbita'))
// store.subscribe(isConnect(store, 'miraflores'))

const ROOT = (
  <Provider store={store}>
    <BrowserRouter>
      <Route path='/' component={App} />
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(ROOT, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js